export default __webpack_public_path__ + "static/media/stone1.39d03d28.png";